wbApp.factory('tenantSettingSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var TenantSetting = $resource('/Api/TenantSettings/:id', {}, {
            'get': { method: 'GET', isArray: false, url: '/Api/TenantSettings/Get' },
            'update': { method: 'POST', url: '/Api/TenantSettings/Update' },
            'triggerPortalUpdate': { method: 'POST', url: '/Api/TenantSettings/TriggerPortalUpdate' },
        });

        var data = tenantSetting;
        var syncData = true;

        function getAsync() {
            var deferred = null;


            if (syncData) {
                if (!data.$promise) {
                    deferred = $q.defer();
                    data.$promise = deferred.promise;
                    deferred.resolve(data);                    
                }

                return data;
            }

            deferred = $q.defer();
            data = {};
            data.$promise = deferred.promise;

            repositorySvc.customGet('get', TenantSetting, {}, function (d) {
                angular.extend(data, d);
                syncData = true;
                deferred.resolve(data);
            }, function (errorResult) {
                deferred.reject(errorResult);
            });

            return data;
        }

        function update(d, successCallback, errorCallback) {
            syncData = false;

            function success(d) {
                angular.extend(data, d);
                syncData = true;

                if (!!successCallback) {
                    successCallback(d);
                }
            }

            repositorySvc.update(
                TenantSetting,    // $resource
                null,             // collection
                d,             // entity
                success,
                errorCallback);
        }

        function triggerPortalUpdate() {
            return $q(function (resolve, reject) {
                repositorySvc.customPost(
                    'triggerPortalUpdate',
                    TenantSetting,
                    {},
                    resolve,
                    reject
                )
            });
        }


        return {
            settings: data,
            isCourseRegistrationNotificationEnabled: function() {
                return  data.sendEmailsToClients &&
                        !data.disableAllEmails &&
                        !data.disableAllEmailsExceptUserRegistration &&
                        data.enableStudentCourseRegistrationNotification;
            },
            isFullCourseInterestNotificationEnabled: function () {
                return data.sendEmailsToClients &&
                        !data.disableAllEmails &&
                        !data.disableAllEmailsExceptUserRegistration &&
                        data.enableFullCourseInterestNotification;
            },
            getAsync: getAsync,
            update: update,
            triggerPortalUpdate: triggerPortalUpdate
        }
    }]);